import React from 'react'; 
import CompanySignupContainer from 'components/containers/signup/CompanySignupContainer';

const CompanyMemberSignupLayout = () => {
    return <CompanySignupContainer />;
}

export default CompanyMemberSignupLayout;